import { render, staticRenderFns } from "./midwayBoard.vue?vue&type=template&id=5f3dfe60&scoped=true&"
import script from "./midwayBoard.vue?vue&type=script&lang=js&"
export * from "./midwayBoard.vue?vue&type=script&lang=js&"
import style0 from "./midwayBoard.vue?vue&type=style&index=0&id=5f3dfe60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3dfe60",
  null
  
)

export default component.exports